import { FormattedMessage as FM } from "react-intl";

import { UsersIcon } from "components/Icons";
import CardRoomFooter from "./CardRoomFooter";
import broomImg from "./assets/broom2.png";
import { cn } from "tools/ui";

const base =
  "h-42 w-full sm:w-64 mt-2 mb-1 rounded-xl border border-neutral-500 shadow-sm overflow-hidden text-neutral-800 bg-white transition-all hover:shadow-md active:scale-95 active:shadow-lg";

function CardRoom({ onClick, record, layout }) {
  const { state, displayMode } = record;
  const tagStyle =
    layout.tags.state[state] || "bg-gray-100 border-gray-900 text-gray-500";

  return (
    <div className={cn(base, "cursor-pointer")} onClick={() => onClick(record)}>
      <div className=" bg-gray-100 py-2 px-4 flex justify-between h-1/3 line-clamp-2">
        <div className="">
          <span className="font-bold text-xl text-neutral-700">
            {record.name}
          </span>
          <div className="text-teal-800 font-black text-[10px] truncate">
            {record["type_."]?.name}
          </div>
        </div>
        <div
          className={cn(
            "flex px-4 h-8 text-[12px] rounded-full my-auto",
            tagStyle,
          )}
        >
          <span className="my-auto">
            <FM id={`hotel.room.${state}`} defaultMessage={state} />
          </span>
        </div>
        {record.occupied_today && (
          <UsersIcon className="text-teal-600 h-5 w-5 fill-current" />
        )}
      </div>

      <div className="px-4 h-2/3">
        <div className="flex h-8 text-neutral-600 text-md font-bold mx-auto">
          <span className="my-auto">
            <FM id={`hotel.room.${record.cleaning_type}`} />
          </span>
          <div className="my-auto pl-2">
            <img key="broom" className="w-5 h-5" alt="icon-in" src={broomImg} />
          </div>
        </div>
        <CardRoomFooter record={record} displayMode={displayMode} />
      </div>
    </div>
  );
}

export default CardRoom;
